import {BaseModel} from '.'

class InvoiceAddress extends BaseModel {
  defaults () {
    return {
      school_id: '',
      recipient: '',
      line1: '',
      line2: '',
      line3: '',
      zip: '',
      city: ''
    }
  }

  loaded () {
    return this.recipient !== ''
  }

  validateAddress () {
    return false
  }

  // Route configuration
  routes () {
    return {
      fetch: '/schools/{school_id}/invoice',
      save: '/schools/{school_id}/invoice',
      delete: '/schools/{school_id}/invoice',
      create: '/schools/{school_id}/invoice'
    }
  }

  options () {
    return {
      identifier: 'school_id',
      validateOnChange: true,
      methods: {
        fetch: 'GET',
        create: 'PUT',
        save: 'PUT',
        update: 'PUT',
        delete: 'DELETE'
      }
    }
  }
}

export {InvoiceAddress}



//////////////////
// WEBPACK FOOTER
// ./src/models/InvoiceAddress.js
// module id = 886
// module chunks = 1